import { combineReducers } from 'redux';
import { layerReducer } from '../../reducers/layers';
import { layerDetailsReducer } from '../../reducers/layers-detail';
import { queriesReducer } from '../../reducers/select-options';
import { formReducer } from '../../reducers/form';
import { searchReducer } from '../../reducers/search';

const rootReducers = combineReducers({
  layerReducer,
  layerDetailsReducer,
  queriesReducer,
  formReducer,
  searchReducer,
});

export default rootReducers;
